import { Component, Input, OnInit } from '@angular/core';
import { IContact, IContactActivity } from '../../../store/models/contact.model';
import { IUserSessionData } from '../../../store/models/user.model';

@Component({
  selector: 'app-contact-activity-mobile-row',
  templateUrl: './contact-activity-mobile-row.component.html',
  styleUrls: ['./contact-activity-mobile-row.component.scss'],
})
export class ContactActivityMobileRowComponent implements OnInit {

  @Input() item: IContactActivity;
  @Input() currentUser: IUserSessionData;
  @Input() activityType: string;
  @Input() contactInfo: IContact;

  constructor() {
  }

  get date() {
    if (this.activityType === '2') {
      return this.item.message_date;
    }

    return this.item.activity_date;
  }

  get type(): string {
    if (this.activityType === '2') {
      return this.item.message_type;
    }

    return this.item.activity_type;
  }

  get message(): string {
    if (this.activityType === '2') {
      return this.item.message_details;
    }

    return this.item.activity_message;
  }

  get content(): string {
    if (this.activityType === '2') {
      return this.item.message_details;
    }

    return this.item.activity_content;
  }

  ngOnInit(): void {
  }

}
